import { Outlet } from "react-router";
import { Box } from "@mui/material";
import colorConfigs from "../../configs/colorConfigs";
import sizeConfigs from "../../configs/sizeConfigs";

interface MainLayoutProps {
  expanded?: boolean;
}

const MainLayout = (props: MainLayoutProps) => {

  return (
    <Box sx={{ display: "flex", p: 0 }}>
      {props.expanded && <div></div>}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          width: `calc(100% - ${sizeConfigs.sidebar.width})`,
          height: "100vh",
          backgroundColor: colorConfigs.mainBg,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
